<template>
  <v-container fluid>
    <v-row>
      <v-col
        v-for="category in cats"
        :key="category"
        cols="12"
        md="6"
      >
        <app-cat-datatable
          :reportingData="reportingData[category]"
          :category="category"
          :loading="loading"
          @filter="filter"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CatDatatable from './CatDatatable.vue'
  export default {
    components : {
      AppCatDatatable : CatDatatable,
    },
    props: ['reportingData', 'loading', 'cats'],
    data(){
      return {
      }
    },
    created(){

    },
    methods: {
      filter(filter){
        this.$emit('perCriteriaUpdate', filter)
      }
    },
    watch: {
    },
    computed: {
      /*categories(){
        return Object.keys(this.reportingData)
      }*/
    }
  }
</script>